import {
  Modal,
  Text,
  Button,
  Flex,
  createStyles,
  Box,
  Divider,
} from "@mantine/core";
import GreenTickMarkSvg from "../../../../components/Svgs/GreenTickMarkSvg";

const useStyles = createStyles((theme) => ({
  confirmPaymentModal: {
    "& .mantine-Modal-body": {
      backgroundColor: "#F5F5F5",
    },
    "& .mantine-Modal-content": {
      backgroundColor: "#F5F5F5",
    },
    "& .mantine-Modal-header": {
      backgroundColor: "#F5F5F5",
    },
    "& .mantine-Modal-close": {
      color: "#000000",
      width: "24px",
      height: "24px",
      "&:hover": {
        backgroundColor: "#F5F5F5",
      },
    },
    "& .mantine-Modal-title": {
      color: "#000000",
      fontSize: "16px",
      fontWeight: "600",
      lineHeight: "24px",
      letterSpacing: "0.01em",
    },
  },
  confirmPaymentContainer: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "20px",
  },
  amountDueContainer: {
    backgroundColor: "#262626",
    color: "#fff",
    borderRadius: "20px",
    padding: "20px",
    marginTop: "10px",
  },
  noticeBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: ".5rem",
    backgroundColor: "#a6f4c580",
    padding: "5px 10px",
    borderRadius: "30px",
    marginBottom: "1rem",
    color: "#027A48",
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Inter",
    width: "100%",
  },
  notice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    backgroundColor: "#fff",
    padding: "3px 5px",
    borderRadius: "30px",
    color: "#027A48",
    border: "1px solid #027A48",
  },
}));

/**
 * Modal that prompts the user to confirm a payment.
 * @param {bool} opened Whether the modal is opened.
 * @param {function} onClose Callback to close the modal.
 * @param {function} onConfirm Callback to confirm the payment.
 * @param {Array} tokenPackages Available token packages.
 * @param {string} selectedPackage The ID of the selected package.
 * @param {string} selectedTab The currently selected tab.
 * @returns {ReactElement} The modal component.
 */
export const PaymentConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  tokenPackages,
  selectedPackage,
  selectedTab,
}) => {
  const pkg = tokenPackages?.find((item) => item._id === selectedPackage);

  const { classes } = useStyles();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Confirm payment"
      overlayProps={{ opacity: 0.55, blur: 3 }}
      centered
      size="md"
      radius="lg"
      zIndex={1000}
      transitionProps={{ duration: 200 }}
      className={classes.confirmPaymentModal}
    >
      <Box>
        <Flex align={"center"} justify="center" gap="md">
          <Box className={classes.noticeBox}>
            <Box className={classes.notice}>Skai AI</Box>

            <Box className={classes.noticeText}>
              {selectedTab === "onetime-purchase"
                ? "One time payment"
                : "Monthly subscription"}
            </Box>
          </Box>
        </Flex>
      </Box>
      <Box className={classes.confirmPaymentContainer}>
        <Flex direction="column" align="start" justify={"start"} gap=".5rem">
          <Text ff={"Inter"} fw={400} fz={14} c={"#979797"}>
            {pkg?.plan === "custom" ? "Custom" : ""} Credits
          </Text>
          <Text ff={"Inter"} fw={700} fz={30} c={"#262626"}>
            {pkg?.tokens === "unlimited" ? "Unlimited" : pkg?.tokens || 0}
          </Text>
        </Flex>
        <Divider my="md" />
        <Flex direction="column" align="start" justify={"start"} gap=".5rem">
          <Text ff={"Inter"} fw={400} fz={14} c={"#979797"}>
            Details
          </Text>
          {pkg?.revisions && (
            <Flex gap="sm" align="center" justify={"start"}>
              <GreenTickMarkSvg width={24} height={24} />
              <Text ff={"Inter"} fw={400} fz={14} c={"#000000"}>
                Skai Revisions
              </Text>
            </Flex>
          )}
          {pkg?.voiceRecording && (
            <Flex gap="sm" align="center" justify={"start"}>
              <GreenTickMarkSvg width={24} height={24} />
              <Text ff={"Inter"} fw={400} fz={14} c={"#000000"}>
                Speech to Text
              </Text>
            </Flex>
          )}
          {/* {pkg?.allStaff && (
            <Flex gap="sm" align="center" justify={"start"}>
              <GreenTickMarkSvg width={24} height={24} />
              <Text ff={"Inter"} fw={400} fz={14} c={"#000000"}>
                All Staff
              </Text>
            </Flex>
          )}
          {pkg?.tokens && (
            <Flex gap="sm" align="center" justify={"start"}>
              <GreenTickMarkSvg width={24} height={24} />
              <Text ff={"Inter"} fw={400} fz={14} c={"#000000"}>
                Credit
              </Text>
            </Flex>
          )} */}
        </Flex>
      </Box>
      <Box mt="md" className={classes.amountDueContainer}>
        <Text ff={"Inter"} fw={400} fz={14} c={"#fff"}>
          Amount Due:
        </Text>
        <Text ff={"Inter"} fw={600} fz={24} c={"#fff"}>
          ${pkg?.price || 0}
        </Text>
      </Box>
      <Flex justify="end" gap="sm" mt="md">
        <Button color="yellow" onClick={onConfirm} radius="md" c="#000" w={150}>
          Pay
        </Button>
      </Flex>
    </Modal>
  );
};
